export const ERROR_TYPES = Object.freeze({
  REGULAR: "REGULAR",
  UNRECOVERABLE: "UNRECOVERABLE",
} as const);
